import {
  Directive,
  Component,
  ViewContainerRef,
  TemplateRef,
  Input
} from "@angular/core";

@Directive({
  selector: "[repeat]",
})
class TemplateRepeat {
  @Input() repeat: number;
  constructor(private tmpl: TemplateRef<any>, private container: ViewContainerRef) { }
  ngOnChanges() {
    for (var i = 0; i < this.repeat; i++) {
      this.container.createEmbeddedView(this.tmpl);
    }
  }
}

@Component({
  selector: 'core-viewcontainerref',
  template: `
  <usecase-container title="ViewContainerRef" src="core/viewcontainerref">
    <usecase-content>
      <p *repeat="3">3 times repeated</p>
    </usecase-content>
  </usecase-container>
  `,
  directives: [
    TemplateRepeat
  ]
})
export class ViewContainerRefComponent {
}



/** WEBPACK FOOTER **
 ** ./script/core/viewcontainerref/component.ts
 **/